import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb.tsx';
import { Link } from '@tanstack/react-router';
import { Fragment } from 'react';

type AppBreadcrumbItem = {
  text: string;
  href?: string;
};
type Props = {
  items: AppBreadcrumbItem[];
};

export function AppBreadcrumbs({ items }: Props) {
  return (
    <Breadcrumb className="my-4 md:my-8">
      <BreadcrumbList className="justify-center">
        {items.map((item, index) => (
          <Fragment key={index}>
            <BreadcrumbItem className="text-xs text-muted-foreground uppercase">
              {item.href ? (
                <BreadcrumbLink asChild>
                  <Link to={item.href as any}>{item.text}</Link>
                </BreadcrumbLink>
              ) : (
                <BreadcrumbPage className='text-muted-foreground'>{item.text}</BreadcrumbPage>
              )}
            </BreadcrumbItem>
            {index < items.length - 1 && <BreadcrumbSeparator />}
          </Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
